<div *ngIf="!isLoading && record" style="position: relative;">
  <div class="p-my-3 p-d-flex p-jc-between">
    <span>
      <h1 class="p-mr-3 p-d-inline"> {{ title }} ({{record.id}})</h1>
      <button pButton pRipple icon="pi pi-pencil" label="Edit" type="button"
        class="p-d-inline" (click)="navigateToEdit()"></button>
      <button *ngIf="record.localize" pButton pRipple label="{{ relocalize ? 'Relocalize Collection' : 'Localize Collection' }}" type="button" icon="fa fa-language"
        (click)="modalVisible = true" class="p-ml-5" [disabled]="disabledLocalizeButton"
      ></button>
    </span>
  </div>

  <!-- Main View Body-->
  <div class="p-grid" *ngIf="!isLoading && fields && fields.length > 0">
    <div [class]="isFullWidth ? 'p-col-12' : 'p-col-8'">
      <!-- Cards -->
      <div *ngFor="let card of fields" class="">
        <ng-container [ngSwitch]="card.type">
          <div *ngIf="isStoreEntity">
            <p-tag [rounded]="true" [icon]="getIcon(storeEnv)" [severity]="getSeverity(storeEnv)"
              [value]="storeEnv | uppercase"></p-tag>
          </div>
          <p-card *ngSwitchCase="cardType.Card" [header]="card.title">
            <div class="p-grid p-mx-5">
              <!-- Fields -->
              <div class="p-col-{{card.columns ? (12 /card.columns) : field.columnWidth ? field.columnWidth : 12 }}"
                *ngFor="let field of card.fields">
                <ng-container *ngIf="shouldDisplayField(field, record)">
                  <ng-container [ngSwitch]="field.inputType">
                    <div *ngSwitchCase="ViewType.BaseViewField" style="width: 100%;">
                      <app-base-view-field [field]="field" [record]="record" [viewTypes]="field.viewTypes"
                        [options]="field.options"></app-base-view-field>
                    </div>
                    <div *ngSwitchCase="ViewType.TableView">
                      <app-ag-grid-base-table
                        [columnDefs]="field.options.columnDefs"
                        [rowData]="record[field.key]"
                      ></app-ag-grid-base-table>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </p-card>
          <br>
          <p-card *ngSwitchCase="cardType.History" [header]="'Build History'" class="p-mx-2 p-shadow-4">
            <app-history [record]="record" [entityType]="entityType"></app-history>
          </p-card>
          <br>
        </ng-container>
      </div>
    </div>
    <!-- right sidebar -->
    <div class="p-col-4">
      <!-- Enabled -->
      <ng-container>
        <h4 class="p-m-2 p-d-none p-d-lg-flex">Enabled:</h4>
        <span class="p-grid p-mb-2 p-text-center p-d-none p-d-lg-flex">
          <ng-container>
            <div class="p-col p-m-2" [ngClass]="record.enabled ? 'green-status' : 'gray-status'">
              <h3 class="p-d-inline p-m-0 p-text-center">
                {{ record.enabled ? 'Enabled' : 'Not Enabled' }}
              </h3>
            </div>
          </ng-container>
        </span>
      </ng-container>
      <ng-container>
        <h4 class="p-m-2 p-d-none p-d-lg-flex">Localizable:</h4>
        <span class="p-grid p-mb-2 p-text-center p-d-none p-d-lg-flex">
          <ng-container>
            <div class="p-col p-m-2" [ngClass]="record.localize ? 'green-status' : 'gray-status'">
              <h3 class="p-d-inline p-m-0 p-text-center">
                {{ record.localize ? 'Yes' : 'No' }}
              </h3>
            </div>
          </ng-container>
        </span>
      </ng-container>
      <ng-container>
        <h4 class="p-m-2 p-d-none p-d-lg-flex">Export to Gamedata:</h4>
        <span class="p-grid p-mb-2 p-text-center p-d-none p-d-lg-flex">
          <ng-container>
            <div class="p-col p-m-2" [ngClass]="record.localizable ? 'green-status' : 'gray-status'">
              <h3 class="p-d-inline p-m-0 p-text-center">
                {{ record.gamedataExportEnabled ? 'Yes' : 'No' }}
              </h3>
            </div>
          </ng-container>
        </span>
      </ng-container>
    </div>
  </div>
  <!-- Toast -->
  <p-toast position="top-right"></p-toast>
</div>